import React from "react";
import {Button, Grid, Paper} from "@mui/material";
import {Link} from "react-router-dom";
import Typography from "@mui/material/Typography";

export default function PreGame() {
    return <React.Fragment>
        <Grid container spacing={2} p={1}>
            <Grid item md={4} sm={6} xs={12}><Button variant="contained" sx={{
                height: "100%",
                width: "100%",
                stretch: "100%",
                textAlign: "center"
            }} component={Link} to={"cabins"}><Typography>Cabin Assignments</Typography></Button></Grid>
            <Grid item md={4} sm={6} xs={12}><Button variant="contained" sx={{
                height: "100%",
                width: "100%",
                stretch: "100%",
                textAlign: "center"
            }} component={Link} to={"tags"}><Typography>Tag Pulls</Typography></Button></Grid>
            <Grid item md={4} sm={6} xs={12}><Button variant="contained" sx={{
                height: "100%",
                width: "100%",
                stretch: "100%",
                textAlign: "center"
            }} component={Link} to={"payments"}><Typography>Payments</Typography></Button></Grid>
            <Grid item md={4} sm={6} xs={12}><Button variant="contained" sx={{
                height: "100%",
                width: "100%",
                stretch: "100%",
                textAlign: "center"
            }} component={Link} to={"outstanding"}><Typography>Log Missing Info</Typography></Button></Grid>

        </Grid>

    </React.Fragment>
}